import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-546913fe")

_pushScopeId("data-v-546913fe")
const _hoisted_1 = { class: "InvoiceHeaderActions" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_icon_download = _resolveComponent("icon-download")!
  const _component_s_icon_button = _resolveComponent("s-icon-button")!
  const _component_icon_vector_left = _resolveComponent("icon-vector-left")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_icon_edit = _resolveComponent("icon-edit")!
  const _component_icon_email = _resolveComponent("icon-email")!
  const _component_icon_cancel = _resolveComponent("icon-cancel")!
  const _component_icon_print = _resolveComponent("icon-print")!
  const _component_icon_image = _resolveComponent("icon-image")!
  const _component_cancel_invoice = _resolveComponent("cancel-invoice")!
  const _component_s_modal = _resolveComponent("s-modal")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.invoiceState.data && _ctx.invoiceState.data.attachment_url)
      ? (_openBlock(), _createBlock("a", {
          key: 0,
          href: _ctx.invoiceState.data.attachment_url,
          target: "_blank",
          download: ""
        }, [
          _createVNode(_component_s_icon_button, { content: "Скачать скан" }, {
            default: _withId(() => [
              _createVNode(_component_icon_download)
            ]),
            _: 1
          })
        ], 8, ["href"]))
      : _createCommentVNode("", true),
    (_ctx.invoiceState.data)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: `/order/ltl/${_ctx.invoiceState.data.order_id}`
        }, {
          default: _withId(() => [
            _createVNode(_component_s_icon_button, { content: "Перейти к заказу" }, {
              default: _withId(() => [
                _createVNode(_component_icon_vector_left)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (_ctx.isCanUpdateCargo)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 2,
          to: `/invoice/${_ctx.$route.params.invoice_id}/update`
        }, {
          default: _withId(() => [
            _createVNode(_component_s_icon_button, { content: "Редактировать" }, {
              default: _withId(() => [
                _createVNode(_component_icon_edit)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (Boolean(_ctx.invoiceState.data))
      ? (_openBlock(), _createBlock(_component_s_icon_button, {
          key: 3,
          content: "Отправить на почту",
          onClick: _ctx.startSendToEmail
        }, {
          default: _withId(() => [
            _createVNode(_component_icon_email)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (
                _ctx.invoiceState.data &&
                _ctx.invoiceState.data.status &&
                (_ctx.invoiceState.data.status.code === 201 || _ctx.invoiceState.data.status.code === 202)
            )
      ? (_openBlock(), _createBlock(_component_s_icon_button, {
          key: 4,
          content: "Отменить накладную",
          loading: _ctx.invoiceCancel.state.is_loading,
          onClick: _ctx.openModal
        }, {
          default: _withId(() => [
            _createVNode(_component_icon_cancel)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    (_ctx.invoiceState.data)
      ? (_openBlock(), _createBlock(_component_s_icon_button, {
          key: 5,
          content: "Распечатать",
          onClick: _ctx.printInvoice
        }, {
          default: _withId(() => [
            _createVNode(_component_icon_print)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    (_ctx.invoiceState.data && _ctx.invoiceState.data.invoice_number)
      ? (_openBlock(), _createBlock(_component_s_icon_button, {
          key: 6,
          content: "Печать мест",
          onClick: _ctx.printPlaces,
          loading: _ctx.invoicePlacesState.state.is_loading
        }, {
          default: _withId(() => [
            _createVNode(_component_icon_image)
          ]),
          _: 1
        }, 8, ["onClick", "loading"]))
      : _createCommentVNode("", true),
    (_ctx.modal_state.is_opened)
      ? (_openBlock(), _createBlock(_component_s_modal, {
          key: 7,
          onClose: _ctx.closeModal
        }, {
          body: _withId(() => [
            _createVNode(_component_cancel_invoice, {
              loading: _ctx.invoiceCancel.state.is_loading,
              onClose: _ctx.closeModal,
              onConfirm: _ctx.cancelInvoiceHandler
            }, null, 8, ["loading", "onClose", "onConfirm"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
})